import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["time"];
  initialize() {
    this.timeInMilliseconds = 30000;
    this.timeTarget.textContent = this.timeInMilliseconds / 1000;
    this.interval = setInterval(() => {
      this.timeTarget.textContent = parseInt(this.timeTarget.textContent) - 1;
    }, 1000);
  }
}